"use client";

import { SiteHeader } from "../SiteHeader";
import { deriveLocaleFromPath } from "@/lib/i18n";
import { usePathname } from "next/navigation";

/**
 * Apps section header. Uses SiteHeader so Canadian visitors still see the
 * maple leaf + localized Contact label when they land on app pages from /ca.
 */
export function AppsNav({ subtitle = "Apps" }: { subtitle?: string }) {
  const pathname = usePathname() || "/";
  const { locale, country } = deriveLocaleFromPath(pathname);
  return (
    <SiteHeader
      locale={locale}
      country={country}
      subtitle={subtitle}
      appsMenu="flat"
    />
  );
}
